import { MaterialType } from "../../../../types/materials";

export enum HeaderMenuItemTabBaseColorScheme {
  NeutralPrimaryTitle = "neutral-primary-title",
}

export type HeaderMenuItemTabColorScheme = HeaderMenuItemTabBaseColorScheme | MaterialType;
